/** Shared MUI Menu styling for seller dashboard dark action menus (DRY). */

export const SELLER_DARK_MENU_PAPER_SX = {
  bgcolor: "#262626",
  borderRadius: "16px",
  padding: "6px",
  boxShadow: "0 12px 32px rgba(0, 0, 0, 0.28)",
  minWidth: 168,
  "& .MuiList-root": { py: 0 },
};

export const SELLER_DARK_MENU_ITEM_SX = {
  color: "#FFFFFF",
  fontSize: "13px",
  fontWeight: 500,
  borderRadius: "12px",
  py: 1.1,
  px: 1.5,
  "&:hover": {
    bgcolor: "#3F3F3F",
  },
};
